import script from "./ModalBaseNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBaseNew.vue?vue&type=script&setup=true&lang=js"

import "./ModalBaseNew.vue?vue&type=style&index=0&id=62c87735&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c87735"]])

export default __exports__